import { DynamicBarService } from 'src/app/_components/dynamic-bar/dynamic-bar.service';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormControl } from '@angular/forms';
import { BehaviorSubject, combineLatest, EMPTY, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { AsistenciaService } from '../_services/asistencia.service';
import { ReporteVigilanciaService } from './reporte-vigilancia.service';
import { PersonaService } from '../../../_components/persona/persona.service';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MY_FORMATS } from '../../../_models/moment-formats';
import { WidgetNotificacionComponent } from '../../../_components/widget-notificacion/widget-notificacion.component';
import { CustomAlertService } from 'src/app/_components/custom-alert/custom-alert.service';

@Component({
  selector: 'reporte-vigilancia-tareas',
  standalone: false,
  templateUrl: 'reporte-vigilancia-tareas.component.html',
  styles: [`
      td.mat-column-star {
          width: 20px;
          padding-right: 8px;
      }

      th.mat-column-position, td.mat-column-position {
          padding-left: 8px;
      }

      .mat-table-sticky:first-child {
          border-right: 1px solid #e0e0e0;
      }

      .mat-table-sticky:last-child {
          border-left: 1px solid #e0e0e0;
      }`],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ReporteVigilanciaTareasComponent implements OnInit {

  private errorMessageSubject = new Subject<string>();
  errorMessage$ = this.errorMessageSubject.asObservable();

  periodos = this.route.parent.snapshot.data['periodos'];
  fechaInicioCalendar = moment(this.periodos[0].fechaInicia.substring(0, 10), 'YYYY-MM-DD');
  fechaFinCalendar = moment(this.periodos[0].fechaFin.substring(0, 10), 'YYYY-MM-DD');
  fechaSeleccionada = this.route.snapshot.paramMap.get('fecha') ? this.route.snapshot.paramMap.get('fecha') : moment().format('YYYY-MM-DD');
  fechaCalendar = { mDate: moment(this.fechaSeleccionada), selected: true };
  date = new UntypedFormControl(moment(this.fechaSeleccionada));

  columns = ['codigo', 'alumno', 'materia', 'tarea', 'comentario', 'asistencia'];
  private studentsInputFilterSubject = new BehaviorSubject<string>('');
  studentsInputFilterAction$ = this.studentsInputFilterSubject.asObservable();

  loading = true;
  studentsRawList = [];
  studentsList$ = combineLatest([
    this.reporteVigilanciaService.studentList$,
    this.studentsInputFilterAction$
  ])
    .pipe(
      map(([students, filterValue]) => {
        this.loading = false;
        this.studentsRawList = students.map(student => student.alumno);
        return students.filter(student =>
          student.alumno.apellidosNombres.toLowerCase().indexOf(filterValue) > -1
          || student.materia.nombreCompleto.toLowerCase().indexOf(filterValue) > -1
        );
      }),
      catchError(err => {
        this.loading = false;
        this.errorMessageSubject.next(err);
        return EMPTY;
      })
    );

  private teachersInputFilterSubject = new BehaviorSubject<string>('');
  teachersInputFilterAction$ = this.teachersInputFilterSubject.asObservable();
  selectedTeachersRawList = [];
  filteredTeachers$ = combineLatest([
    this.personaService.colaboradoresOp$,
    this.reporteVigilanciaService.guardingTeachersOp$,
    this.teachersInputFilterAction$
  ]).pipe(
    map(([teachers, selectedTeachers, filterValue]) => {
      selectedTeachers.map(selTeacher => {
        const ind = teachers.findIndex(teacher => teacher.id === selTeacher.id);
        if (ind > -1) {
          teachers.splice(ind, 1);
        }
      });
      this.selectedTeachersRawList = selectedTeachers;
      return {
        teachers: teachers.filter(teacher =>
          teacher.apellidosNombres.toLowerCase().indexOf(filterValue) > -1
        ),
        selectedTeachers: selectedTeachers
      };
    }
    ),
    catchError(err => {
      return EMPTY;
    })
  );

  canNotify$ = this.reporteVigilanciaService.canNotify$;

  visible = true;
  selectable = true;
  removable = true;
  teacherCtrl = new UntypedFormControl();

  commentSubscription;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private title: Title,
    public dialog: MatDialog,
    private asistenciaService: AsistenciaService,
    private reporteVigilanciaService: ReporteVigilanciaService,
    private personaService: PersonaService,
    private dynamicBarService: DynamicBarService,
    private customAlertService: CustomAlertService) {
    this.reporteVigilanciaService.selectedDateChange(this.route.snapshot.paramMap.get('fecha') ?
      this.route.snapshot.paramMap.get('fecha') : moment().format('YYYY-MM-DD'));
  }

  ngOnInit() {
    this.dynamicBarService.setBarra('reporte-vigilancia-tareas-barra');
    this.title.setTitle('Vigilancia de tareas - MiGLM');
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  changeDate(date) {
    this.router.navigate(['/', 'asistencia', 'reporte', 'vigilancia-tareas', 'fecha', date.format('YYYY-MM-DD')]);
  }

  filterStudents(value): void {
    this.studentsInputFilterSubject.next(value.toLowerCase());
  }

  filterTeachers(value): void {
    this.teachersInputFilterSubject.next(value.toLowerCase());
  }

  onSelectTeacher(teacher): void {
    this.reporteVigilanciaService.addVigilante(teacher.option.value).subscribe(data => {
      this.personaService.removeTeacher(teacher.option.value);
    }, err => {

    }, () => {
    });
  }

  onDeleteTeacher(teacher): void {
    this.reporteVigilanciaService.removeVigilante(teacher).subscribe(data => {
      this.personaService.addTeacher(teacher);
    }, err => {
    }, () => {
    });
  }

  updateComment(value, model, spinner) {
    if (this.commentSubscription) {
      this.commentSubscription.unsubscribe();
    }
    spinner.style.display = 'block';
    model.comentarioRevision = value;
    this.commentSubscription = this.asistenciaService.updateFaltaTarea(model).subscribe(res => {
      spinner.style.display = 'none';
    }, err => {
      spinner.style.display = 'none';
    }, () => {
    });
  }

  setPresentState(checked, model) {
    model['asistio'] = checked;
    this.asistenciaService.updateFaltaTarea(model).subscribe(res => {
      // TODO: Handle success
    }, err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No se ha podido guardar la observación. ${err.error} <br> Código de error: ${err.statusText}`
      });;
    }, () => {
    });
  }


  notify(personType: string): void {
    const list = personType === 'Profesores' ? this.selectedTeachersRawList : this.studentsRawList;
    const dialogRef = this.dialog.open(WidgetNotificacionComponent, {
      width: '75%',
      data: {
        widgetTitle: `Notificar ${personType.toLowerCase()}`,
        fromListTitle: `${personType} citados`,
        toListTitle: `${personType} a notificar`,
        fromList: list,
        showComment: true,
        modelData: {
          fecha: this.fechaSeleccionada,
          tipoOrigen: personType === 'Profesores' ? 'asistenciaTareaCuidador' : 'asistenciaTareaAlumno'
        }
      },
      disableClose: true
    });
  }
}
